var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6126 17C17.6706 17 19 15.874 19 14.1316C19 12.153 17.4941 11.6819 16.0374 11.226C14.5956 10.7733 14.1563 10.4361 14.1563 9.7821C14.1563 9.30113 14.5383 8.81591 15.392 8.81591C16.1943 8.81591 16.7419 9.15023 17.1426 9.89291L18.6589 8.97293C17.9776 7.68091 16.8519 7 15.392 7C13.8802 7 12.3493 7.97515 12.3493 9.83963C12.3493 11.6617 13.7124 12.3015 15.0454 12.6868C16.3766 13.0678 17.193 13.3432 17.193 14.1604C17.193 14.4683 17.0457 15.1836 15.6817 15.1836C14.6925 15.1836 13.998 14.7569 13.565 13.8812L12 14.8219C12.5835 16.2281 13.8597 17 15.6126 17Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4047 13.3183C11.3735 12.752 12 11.6179 12 10.4286C12 8.53811 10.6667 7 9.02802 7H6V10.2792H7.72167V9.30341C7.72167 9.16409 7.84896 9.07337 7.95714 9.13602L9.75005 10.1725C9.86952 10.2416 9.86952 10.4386 9.75005 10.5077L7.95714 11.5442C7.84896 11.6068 7.72167 11.5161 7.72167 11.3768V10.401H6V10.7819V11.2134V17H7.63348C7.66346 16.9644 7.69474 16.9303 7.72602 16.8963V13.7048H8.55926L9.60843 15.8297C9.84693 15.7796 10.088 15.7531 10.3274 15.7531C10.7319 15.7531 11.1172 15.8082 11.4795 15.9155L10.224 13.4236L10.4047 13.3183Z",
    fill: "#272727"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.1,
    stroke: "#272727",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsIcon);
export default __webpack_public_path__ + "static/media/rs-icon.5c51fa64f7ac26267d0e7008a2e32d7e.svg";
export { ForwardRef as ReactComponent };